export enum QualificationView {
  BROWSE = 1,
  USER_DETAIL = 2,
  LIST = 3,
  EXPORT = 4,
  EDIT = 5,
}
